export default "__VITE_ASSET__ArPkr$yT__"